import {httpRequest} from "../../../utils/HttpRequest";
import {IJournalSearch,IJournalDetail,ReviewTypes} from "./dataJournalTypes"
import {IPage} from "../../../types/FmsTypes";

class JournalService {
    async page(params:IJournalSearch){
        const apiUrl = "/mdm/change/page"
        return await httpRequest.post<IPage<IJournalDetail>>(apiUrl,params)
    }
    async review(ids:ReviewTypes){
        const apiUrl = "/mdm/change/review"
        return await httpRequest.post<boolean>(apiUrl,ids)
    }
}
const journalService = new JournalService()
export {
    journalService
}